import type { TopNConfig, TransformRow } from './types';

export function topN(rows: TransformRow[], config: TopNConfig): TransformRow[] {
  if (!Number.isFinite(config.n) || config.n <= 0) return rows;
  return rows.slice(0, Math.floor(config.n));
}
